// extracted by mini-css-extract-plugin
module.exports = {"__power_center_card_details":"PowerCenterCardDetails___power_center_card_details__2nZgt","__pwers_header_title":"PowerCenterCardDetails___pwers_header_title__2k6Qk"};